<template>
    <sa-page-layout :btnAnnullaVisible="true" :btnSaveVisible="true" :linkback="linkback" :data="jsonDataSettingLivelli" @aftersave="onAfterSave" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <rsa-configurazione-setting-livelli-edit-component ref="RsaConfigurazioneSettingLivelliEditComponent" :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></rsa-configurazione-setting-livelli-edit-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneSettingLivelliEditComponent from "../components/RsaConfigurazioneSettingLivelliEditComponent.vue";

export default {
    components: { SaPageLayout, RsaConfigurazioneSettingLivelliEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsasettinglivelli",
            linkback: "/configurazioni/settingslivelli",
            jsonDataSettingLivelli: {},
            id: "-1",
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonDataSettingLivelli = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onAfterSave() {
            /*   let me = this;
      me.id = me.$route.params.id;
      if (me.id === "-1") {
        me.$router.replace(me.linkback).catch((err) => {
          console.log(err);
        });
      } */
        },
    },
};
</script>

<style></style>
